import { useCallback, useState } from "react";
import { EditNichePopup } from "./EditNichePopup";
import { useEditNicheMutation } from "@/common/queries/queries";
import { EDIT_NICHE_FIELDS, getFieldsWithValues } from "./helpers";
import { showNotification } from "@/components/alerts/Notifications";
import { IEditNichePopupContainerProps } from "@/common/buses/popups/popup-types";
import { onCloseEditNichePopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { INicheForm } from "components/popups/NicheForm/NicheForm";

export const EditNichePopupContainer: React.FC<IEditNichePopupContainerProps> = ({ niche }) => {
  const [ticketId, setTicketId] = useState<string>("");
  const editNicheMutation = useEditNicheMutation(niche.id);

  const onSubmit = async (data: INicheForm) => {
    try {
      await editNicheMutation.mutateAsync({
        id: niche.id,
        description: data.description,
        rules: data.rules,
        image: ticketId || null
      });

      handleClose();
      showNotification({
        title: "Successfully Updated",
        variant: "success"
      });
    } catch (e) {
      console.error(e);
      showNotification({
        title: "Something went wrong. Please try later",
        variant: "error"
      });
    }
  };

  const handleClose = useCallback(() => {
    onCloseEditNichePopup();
  }, []);

  const handleTicketId = (ticketId: string) => {
    setTicketId(ticketId);
  };

  const nicheValues = {
    name: niche.name,
    description: niche.description,
    rules: niche.rules
  };

  const nicheFields = getFieldsWithValues(EDIT_NICHE_FIELDS, nicheValues);

  return (
    <EditNichePopup
      nicheFields={nicheFields}
      onClose={handleClose}
      isOpen={true}
      handleTicketId={handleTicketId}
      ticketId={ticketId}
      onSubmit={onSubmit}
      preview={niche.thumbnail}
    />
  );
};
